import React, { useState, useEffect } from 'react';
import { getCanvas as getBarcodeCanvas } from 'pxc-editor-core/helpers/barcode';

const BarcodeImage = (props) => {
  const { rectProps, formatProps } = props;
  const { code, graphicFormattingScale } = formatProps;
  const scaleFactor = graphicFormattingScale;
  const { text, ...barcodeOptions } = code;
  const rectFactor = parseFloat(
    (rectProps.width / rectProps.height).toFixed(2),
  ); 
  const [imageFactor, setImageFactor] = useState(1);
  const [imageСoordinates, setImageСoordinates] = useState({ x: 0, y: 0 });
  const [imageDataUrl, setImageDataUrl] = useState('');

  const handleImageFactor = (image) => {
    if (image.width || image.height) {
      setImageFactor(parseFloat((image.width / image.height).toFixed(2)));
    } else {
      setImageFactor(1);
    }
  };

  const getX = () => {
    if (rectFactor > imageFactor) {
      return (rectProps.width - (rectProps.height * scaleFactor) * imageFactor) / 2; // by center
    }
    return (rectProps.width - rectProps.width * scaleFactor) / 2;
  };

  const getY = () => {
    if (rectFactor < imageFactor) {
      return (rectProps.height - (rectProps.width * scaleFactor) / imageFactor) / 2; // by center
    }
    return (rectProps.height - rectProps.height * scaleFactor) / 2;
  };

  const handleCoordinatesChange = () => {
    const x = getX();
    const y = getY();

    setImageСoordinates({ x, y });
  };

  const handleImageRender = () => {
    const canvas = getBarcodeCanvas(text, barcodeOptions);
    const url = canvas.toDataURL();
    const img = new Image();

    img.src = url;
    img.onload = function () {
      handleImageFactor(img);
      setImageDataUrl(url);
    };
  };

  useEffect(() => {
    handleImageRender();
  }, [code]);

  useEffect(() => {
    handleCoordinatesChange();
  }, [
    imageDataUrl,
    rectProps.x,
    rectProps.y,
    rectProps.width,
    rectProps.height,
    barcodeOptions.textxalign,
    barcodeOptions.textyalign,
    scaleFactor,
  ]);

  const width = rectFactor > imageFactor ? undefined : rectProps.width * scaleFactor;
  const height = rectFactor > imageFactor ? rectProps.height * scaleFactor : undefined;

  return (
    <image
      href={imageDataUrl}
      width={width}
      height={height}
      x={imageСoordinates.x}
      y={imageСoordinates.y}
    />
  );
};

const Barcode = (props) => {
  const { id, rectProps, formatProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id={id}
      width={rectProps.width}
      height={rectProps.height}
      x={rectProps.x}
      y={rectProps.y}
    >
      <BarcodeImage rectProps={rectProps} formatProps={formatProps} />
    </svg>
  );
};

export default Barcode;
